import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const listDataService = {
  getData: async (user, listId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/list-data/list/${listId}`,
      getAxiosOptions(user)
    )
  },
  getDataActivity: async (user, activityId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/list-data/activity-list-data/${activityId}`,
        getAxiosOptions(user)
      )
    ).data
  },
  getListDataMetadata: async (user, activityTemplateId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/field/activity/list-data-metadata/${activityTemplateId}`,
      getAxiosOptions(user)
    )
  },
  getListOfListsForAdmin: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/template/list/company`, getAxiosOptions(user))).data
  },
}
